const _noretraySetting = {
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  retry: false,
};

const createRegister = (set, _get) => ({
  PersonalInfo: {},
  setPersonalInfo: PersonalInfo => {
    set({ PersonalInfo });
  },
  setStep: (stepNumber: number) => {
    set({ step: stepNumber });
  },
  step: 1,

  // Register(): QueryMutationResult<any> {
  //   return useMutation(["Register"], Register);
  // },

  // ValidateUserExist(): QueryMutationResult<{ email?: string | undefined }> {
  //   return useMutation(["PostChangePassword"], ValidateUserExist);
  // },

  // ConfirmEmail(data: { userId: string; code: string }, enabled: boolean): QueryResult<AxiosApiResponse<any>> {
  //   return useQuery(["ConfirmEmail"], () => ConfirmEmail(data), { ...noretraySetting, enabled });
  // },
});

export default createRegister;
